module.exports = __webpack_public_path__ + "static/img/1981_phase_function_Paper_PointsHejduk_Prediction.3ab3b4a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/1981_phase_function_Paper_PointsHejduk_Prediction.png
// module id = L4KI
// module chunks = 0